import styled from '@emotion/styled';
import { N30, N90 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const ContentWrapper = styled.div({
  display: 'flex',
  height: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const SearchFooterLabelWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  fontSize: '12px',
  gap: "var(--ds-space-050, 4px)",
  color: `var(--ds-text-subtle, ${N90})`
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const SearchFooterLabel = styled.div({
  backgroundColor: `var(--ds-background-neutral, ${N30})`,
  padding: `0px ${"var(--ds-space-025, 2px)"}`,
  borderRadius: '4px'
});